import type { ReactNode } from 'react'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@klear/ui/components/button'

export function UploadStep({ onBack, busy, children }: { onBack: () => void; busy: boolean; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-4">
      <Button type="button" variant="ghost" size="sm" className="-ml-2 self-start" onClick={onBack} disabled={busy}>
        <ArrowLeft className="mr-1 h-4 w-4" />
        Back
      </Button>
      {children}
    </div>
  )
}
